import { cn } from "@/lib/utils";
import { Trans } from "@lingui/react/macro";
import { Loader2 } from "lucide-react";
import * as React from "react";

type FullScreenLoadingProps = {
  /**
   * Pass translated JSX when you want custom text:
   *   title={<Trans>Loading…</Trans>}
   */
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  "aria-live"?: "polite" | "assertive" | "off";
};

export function FullScreenLoading({
  title,
  description,
  className,
  "aria-live": ariaLive = "polite",
}: FullScreenLoadingProps) {
  return (
    <div
      className={cn("min-h-dvh w-full grid place-items-center p-6", className)}
      role="status"
      aria-live={ariaLive}
      aria-busy="true"
    >
      <div className="flex flex-col items-center text-center gap-3">
        <Loader2
          className="h-7 w-7 animate-spin text-muted-foreground"
          aria-hidden="true"
        />
        <div className="space-y-1">
          <p className="text-sm font-medium">
            {title ?? <Trans>Loading…</Trans>}
          </p>
          {description ? (
            <p className="text-sm text-muted-foreground">{description}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
